import { createContext, useContext, useState, useEffect } from "react";
import { STORAGE_THEME } from "../utils/storageKeys";

export const CustomThemeContext = createContext({ isDark: false, toggle: () => {} });

/* Provider global — envuelve toda la app en index.js */
export const CustomThemeProvider = ({ children }) => {
  /* Inicialización síncrona desde localStorage: elimina el flash en navegación */
  const [isDark, setIsDark] = useState(() => localStorage.getItem(STORAGE_THEME) === "dark");

  /* Sincroniza el atributo CSS en el <html> para que las variables dark/light de index.css funcionen */
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", isDark ? "dark" : "light");
  }, [isDark]);

  const toggle = (checked) => {
    setIsDark(checked);
    localStorage.setItem(STORAGE_THEME, checked ? "dark" : "light");
  };

  return (
    <CustomThemeContext.Provider value={{ isDark, toggle }}>
      {children}
    </CustomThemeContext.Provider>
  );
};

/* Hook para consumir el tema en cualquier componente */
export const useAppTheme = () => useContext(CustomThemeContext);

/* Hook de estilos — devuelve colores reactivos al tema para usarlos en inline styles */
export const useThemeStyles = () => {
  const { isDark } = useAppTheme();
  return {
    isDark,
    bg:      isDark ? "#122333" : "#ffffff",
    bgAlt:   isDark ? "#0d1e2c" : "#f8fcfe",
    text:    isDark ? "#d0eaf5" : "#1a3a4a",
    textSub: isDark ? "#7aafca" : "#5c8fa0",
    border:  isDark ? "#1e3d52" : "#e0f4fb",
    shadow:  isDark
      ? "rgba(0,0,0,0.25)"
      : "rgba(37,150,190,0.06)",
  };
};
